export function parseChatPush(data) {
    if (
        data?.type !== "chat" ||
        typeof data.tenant !== "string" ||
        !/^[a-z0-9][a-z0-9-]{0,62}$/.test(data.tenant)
    )
        return null;
    if (
        ![data.group_id, data.user_id, data.message_id].every(
            (id) => typeof id === "string" && /^[a-f0-9]{24}$/.test(id)
        )
    )
        return null;
    return {
        tenant: data.tenant,
        group: data.group_id,
        user: data.user_id,
        ...(data.mention === "true" ? { message: data.message_id } : {})
    };
}
